import React, { memo } from "react";
import CoreButtons from "../../../core-components/button/CoreButtons";
import { IPhotoLibraryPhoto } from "../../../../interfaces/photoLibrary";
import { IAttachmentFile } from "../../../../interfaces/corporateEvent";
import "./PhotoLibraryFooter.scss";

interface PhotoLibraryFooterProps {
	selectedPhotos: IPhotoLibraryPhoto[];
	onClose: () => void;
	onAttachmentsChange: (attachments: IAttachmentFile[]) => void;
	onClearSelection: () => void;
}

const PhotoLibraryFooter: React.FC<PhotoLibraryFooterProps> = ({
	selectedPhotos,
	onClose,
	onAttachmentsChange,
	onClearSelection,
}) => {
	const handleDone = () => {
		onClose();
		onAttachmentsChange(
			selectedPhotos.map((photo) => ({
				id: photo.id,
				fileName: photo.fileName,
				fileUrl: photo.fileUrl,
				createdAt: photo.createdAt,
				updatedAt: photo.updatedAt,
			})),
		);
	};

	const handleCancel = () => {
		onClose();
		onClearSelection();
	};

	return (
		<div className="picker-footer">
			<CoreButtons className="cancel-btn" onclick={handleCancel} buttonText="Cancel" />

			{selectedPhotos.length > 0 && (
				<div className="selected-preview-stack">
					<div className="preview-thumbnails">
						{selectedPhotos.slice(0, 3).map((photo, index) => (
							<div
								key={photo.id}
								className="preview-thumbnail"
								style={{
									backgroundImage: `url(${photo.fileUrl})`,
									zIndex: 3 - index,
									transform: `translateX(${index * -8}px)`,
								}}
							/>
						))}
					</div>
					<span className="preview-stack-label">{selectedPhotos.length} selected</span>
				</div>
			)}

			<CoreButtons
				className="done-btn"
				onclick={handleDone}
				disabled={selectedPhotos.length === 0}
				buttonText={`Done (${selectedPhotos.length})`}
			/>
		</div>
	);
};

export default memo(PhotoLibraryFooter);

